export const RayIcon = () => {
  return (
    <svg className="h-5 w-5" viewBox="0 0 485 485" xmlns="http://www.w3.org/2000/svg">
      <polygon points="353.125,180.403 292.601,180.403 381.354,0 252.754,0 120.551,268.709 189.479,268.709 103.646,485 		" />
    </svg>
  );
};
